import React from 'react';
import * as _ from 'lodash';
import { CompanyBranchService } from '../../../services/CompanyBranches';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import {
  DROPDOWN_SEARCH_DEBOUNCE_TIMEOUT,
  REQUEST_PARAMS,
  // FIELD_ITEM_LISTS
} from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import { FormDropdownRadio } from '../../CommonFormComponents';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';

export class BranchListDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      opened: false,
      selected: null,
      selectedName: null,
      options: {},
      error: '',
      condition: {
        name: '',
      },
      isLoading: true, // ロード中フラグ
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-prime-id-${this.id}`;
    this.search = this.search.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.setCondition = this.setCondition.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.getPrimes = this.getPrimes.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.searchTimer;
  }

  componentDidMount() {
    this.getPrimes(() => {});
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.selected && nextProps.value > 0) {
      this.setState({ selected: nextProps.value });
    }
    if (
      nextProps.branchName !== this.state.selectedName &&
      nextProps.branchName
    ) {
      this.setState({ selectedName: nextProps.branchName });
    }
  }

  componentDidUpdate() {
    if (this.state.opened) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });
  };

  handleOpen = () => {
    this.setState({ opened: !this.state.opened });
  };

  setCondition = e => {
    let condition = this.state.condition;
    condition.name = e.target.value;
    this.setState({ condition }, () => {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.search();
      }, DROPDOWN_SEARCH_DEBOUNCE_TIMEOUT);
    });
  };

  search = () => {
    this.setState(
      { options: {}, loaded: false, isLoading: true },
      () => {
        this.getPrimes(() => {});
      }
    );
  };

  handleSelectedRow = (id, checked) => {
    let selected = null;
    let selectedName = null;
    if (checked) {
      selected = id;
      selectedName = _.get(this.state.options[selected], 'name');
    }
    if (this.props.useKYOnly) {
      this.setState({ opened: false });
      this.props.set(selectedName, selected);
    } else {
      this.setState({ selected, selectedName, opened: false });
      this.props.set('company_id', selected);
    }
  };

  getPrimes(notify) {
    if (this.state.loaded) {
      notify();
      this.setState({ isLoading: false });
      return;
    }

    let params = {
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.size(this.state.options),
      name: this.state.condition.name,
      ...(this.props.useKYOnly && { use_ky_flag: 1 }),
    };

    CompanyBranchService.companyBranchList(params).then(response => {
      if (response.result) {
        const companies = response.data.entities.company_branches;
        if (_.isEmpty(companies)) {
          this.setState({ loaded: true });
        } else {
          let options = this.state.options;
          _.each(companies, company => {
            options[company.id] = company;
          });
          this.setState({
            options,
            loaded: false,
          });
        }
      }
      this.setState({ isLoading: false });
      notify();
    });
  }

  render() {
    const displayName = this.state.selectedName || '支店を選択';
    return (
      <div className='BranchListDropdown' ref={this.parent}>
        <div id='form-dropdown' className='dropdown-single-select'>
          {this.props.readOnly ? (
            <span>{displayName}</span>
          ) : (
            <React.Fragment>
              <div
                className={`dropdown-single-select__header ${
                  this.state.opened ? 'show' : ''
                }`}
              >
                <div
                  id='form-dropdown-btn'
                  className='dropdown-select'
                  onClick={() => this.handleOpen()}
                >
                  <span className='dropdown-select__txt'>{displayName}</span>
                </div>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </div>
              {this.state.opened && (
                <div
                  id='form-dropdown-list'
                  className='dropdown dropdown--dropdown-list show'
                >
                  <div className='dropdown__item dropdown__item--hidden'>
                    <div className='dropdown-single-select__item'>
                      <i className='i-search i-2x' />
                      <input
                        type='text'
                        placeholder={messageUtility.getMessage('I-000-090')}
                        defaultValue={this.state.condition.name}
                        onChange={e => this.setCondition(e)}
                      />
                    </div>
                    <div className='dropdown-single-select__item'>
                      <div
                        className='dropdown-single-select__scroll'
                        id={this.targetId}
                      >
                        <ul className='single-select'>
                          {_.map(this.state.options, (option, index) => (
                            <FormDropdownRadio
                              key={index}
                              option={option}
                              checked={this.state.selected == option.id}
                              targetId={this.id}
                              handleSelectedRow={this.handleSelectedRow}
                              forId='single-prime-id'
                            />
                          ))}
                          <InfinityScrollLoad
                            targetId={this.targetId}
                            total={_.size(this.state.options)}
                            isLoading={this.state.isLoading}
                            callback={this.getPrimes}
                          />
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/BranchList.jsx